'use client';

import { useBuilding } from '../../context/BuildingProvider';
import { Ratings } from '@/components/shared/Ratings';

export function BuildingRatings() {
  const { buildingRatings, isMasked } = useBuilding();

  return <Ratings ratings={buildingRatings} isMasked={isMasked} />;
}
